import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";
import { get } from "src/services/content.service";
import { useDispatch } from "react-redux";
import { showAlert } from "src/redux/slices/AlertSlice";
import { useTranslation } from "react-i18next";

const GroupDialog = ({ open, onClose, group }) => {
    const [users, setUsers] = useState([]);
    const [contents, setContents] = useState([]);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        if (group) {
            const fetchDetails = async () => {
                try {
                    const res = await get(dispatch, `/api/accounts/groups/${group.id}/`);
                    setUsers(res.data.users || []);
                    setContents(res.data.contents || []);
                } catch (err) {
                    dispatch(showAlert({ message: err, severity: "error" }));
                }
            };
            fetchDetails();
        }
    }, [group]);

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>{t("Group.GroupDialog.title", { groupName: group?.name })}</DialogTitle>
            <DialogContent dividers>
                <h4>{t("Group.GroupDialog.users")}</h4>
                <ul>
                    {users.map((u) => (
                        <li key={u.id}>{u.name} ({u.email})</li>
                    ))}
                </ul>
                <h4>{t("Group.GroupDialog.content")}</h4>
                <ul>
                    {contents.map((c) => (
                        <li key={c.id}>{c.title}</li>
                    ))}
                </ul>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{t("buttonCommons.finish")}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default GroupDialog;
